// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1479150","239":"8ae740c0","667":"9c1ed12b"}[chunkId] + ".chunk.js";
};